
import Vue from 'vue';
import ToolTip from '@/components/common/ToolTip.vue';

export default Vue.extend({
	name: 'UploadExcel',
	components: {
		ToolTip,
	},

	props: {
		componentName: { type: String, default: 'file' },
		acceptableFiles: { type: String, default: '' },
		fileType: {
			type: String,
			required: true,
			validator: (value: string) => ['file', 'picture'].includes(value),
		},
		inputNames: { type: String, default: 'file' },
		userPermission: { type: Boolean, default: true },
	},

	data() {
		return {
			file: null as File | null,
		};
	},

	computed: {
		inputNameChecker(): string {
			return this.inputNames === 'file' ? this.$t(this.inputNames).toString() : this.inputNames;
		},
	},

	methods: {
		async sendFile() {
			if (!this.file) {
				this.$emit('errorStatus', this.$t('error_file_upload_missing_file'));
				return;
			}

			const form = new FormData();
			form.append('file', this.file!);
			switch (this.fileType) {
				case 'file':
					this.$emit('sendFile', form);
					this.file = null;
					break;
				case 'picture':
					if (this.checkFileType(this.file, 'picture')) {
						const base64File = await this.toBase64(this.file!);
						this.$emit('sendFile', base64File);
					} else {
						this.$emit('errorStatus', this.$t('error_picture_upload_format'));
					}
					break;
			}
		},

		checkFileType(file: File, type: string): boolean {
			switch (type) {
				case 'picture':
					return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'].includes(file.type);
				default:
					return true;
			}
		},

		toBase64(file: File): Promise<string | ArrayBuffer | null> {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => resolve(reader.result);
				reader.onerror = (error) => reject(error);
			});
		},
	},
});
